package com.arena_web.data.api

import com.arena_web.data.dto.*
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiPost
import io.ktor.client.*

class AuthApi(private val client: HttpClient) {

    suspend fun register(request: RegisterRequest): ApiResponse<AuthResponse> {
        return client.apiPost("v1/auth/register", request)
    }

    suspend fun login(request: LoginRequest): ApiResponse<AuthResponse> {
        return client.apiPost("v1/auth/login", request)
    }

    suspend fun oauthGoogle(request: OAuthLoginRequest): ApiResponse<AuthResponse> {
        return client.apiPost("v1/auth/oauth/google", request)
    }

    suspend fun oauthApple(request: OAuthLoginRequest): ApiResponse<AuthResponse> {
        return client.apiPost("v1/auth/oauth/apple", request)
    }

    suspend fun refresh(request: RefreshTokenRequest): ApiResponse<RefreshTokenResponse> {
        return client.apiPost("v1/auth/refresh", request)
    }

    suspend fun logout(request: LogoutRequest): ApiResponse<Unit> {
        return client.apiPost("v1/auth/logout", request)
    }

    suspend fun logoutAll(): ApiResponse<Unit> {
        return client.apiPost("v1/auth/logout-all")
    }
}
